import { sendKlaviyoRecommendationsEvent } from '@/app/api/klaviyo-event'
import { INIT_DATA_STORAGE_KEY } from '@/app/constants'
import { HotelItem, UserData } from '@/app/types'
import { useLocalStorage } from '@uidotdev/usehooks'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { FC, useEffect, useState } from 'react'

interface Props {
	hotels: HotelItem[]
	complete: boolean
}

const RecommendationsEventHandler: FC<Props> = ({ hotels, complete }) => {
	const pathname = usePathname()
	const [eventSent, setEventSent] = useState(false)

	const [userData, _] = useLocalStorage<UserData>(INIT_DATA_STORAGE_KEY)

	useEffect(() => {
		if (complete && userData && userData.email && !eventSent) {
			sendKlaviyoRecommendationsEvent(hotels, userData.email, pathname)
			setEventSent(true)
		}
	}, [complete, userData, hotels, eventSent])
	return null
}

export default dynamic(() => Promise.resolve(RecommendationsEventHandler), {
	ssr: false,
})
